import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {DisplayService} from "../service/display.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TroubleshootCopyService } from '../service/troubleshoot-copy.service';

@Component({
  selector: 'app-troubleshoot',
  templateUrl: './troubleshoot.component.html'
})
export class TroubleshootComponent implements OnInit {

  userName;
  clientTxId;
  lastTransaction;
  lastErrorResponse: { status: number, body: any, contentType?: string } | null = null;
  safeHtmlBody: SafeHtml | null = null;
  isHtmlResponse: boolean = false;
  simplifiedErrorFields: { label: string, value: string }[] | null = null;
  isCopied: boolean = false;

  constructor(public dialogRef: MatDialogRef<TroubleshootComponent>,
              private readonly displayService: DisplayService,
              private readonly sanitizer: DomSanitizer,
              private readonly copyService: TroubleshootCopyService) { }

  ngOnInit() {
    this.userName = this.displayService.userName;
    this.clientTxId = this.displayService.clientTransactionId;
    this.lastTransaction = this.displayService.lastTransaction;
    this.lastErrorResponse = this.displayService.lastErrorResponse;
    if (this.lastErrorResponse?.contentType?.includes('text/html') && typeof this.lastErrorResponse.body === 'string') {
      this.isHtmlResponse = true;
      // The HTML content originates exclusively from network-level firewall responses (e.g. ZScaler),
      // not from user input. It is rendered in a sandboxed read-only diagnostic dialog.
      this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this.lastErrorResponse.body); // NOSONAR
    } else if (this.lastErrorResponse?.body && typeof this.lastErrorResponse.body === 'object') {
      this.simplifiedErrorFields = this.buildSimplifiedErrorFields(this.lastErrorResponse.body);
    }
  }

  private buildSimplifiedErrorFields(body: any): { label: string, value: string }[] | null {
    const fields: { label: string, value: string }[] = [];
    const errorCode = body?.errorCode ?? body?.data?.errorCode;
    const errorMessage = body?.errorMessage ?? body?.data?.errorMessage;
    if (errorCode) { fields.push({ label: 'Error Code', value: errorCode }); }
    if (errorMessage) { fields.push({ label: 'Error Message', value: errorMessage }); }
    return fields.length > 0 ? fields : null;
  }

  async onCopyToClipboard() {
    await this.copyService.copyTroubleshootInfo();
    this.isCopied = true;
  }

  public onClose() {
    this.dialogRef.close();
  }

}
